'use client'

import { useContext } from 'react'
import { AuthContext } from '@wolfdanepug/common-react'
import { CartContext } from '../context/cart'
import { useNavigate } from 'react-router'

export const useLogout = () => {
	const { logout: logoutAuth } = useContext(AuthContext)
	const { clearCart } = useContext(CartContext)
	const navigate = useNavigate()

	return function logout() {
		logoutAuth()
		clearCart()
		navigate('/')
	}
}
